var MoveCloser = function(tileX, tileY) {
    this.moveAway(tileX, tileY, false);
    return this;
}
export default MoveCloser;